export const UPDATE_FL_CONSENSO1_CONTRATTO = 'UPDATE_FL_CONSENSO1_CONTRATTO';
export const UPDATE_FL_CONSENSO2_MARKETING = 'UPDATE_FL_CONSENSO2_MARKETING';
export const UPDATE_FL_CONSENSO3_STATISTIC = 'UPDATE_FL_CONSENSO3_STATISTIC';
export const UPDATE_FL_CONSENSO4_COMUNICAZ = 'UPDATE_FL_CONSENSO4_COMUNICAZ';
export const SALVA_DATI_CONSENSO  		   = 'SALVA_DATI_CONSENSO';
export const UPDATE_DATI_CONSENSO_VALIDA   = 'UPDATE_DATI_CONSENSO_VALIDA';